var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdowncirclefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.5300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.5254 85.6934-35.2539C85.6934-56.9824 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-56.9824 6.83594-35.2539C6.83594-13.5254 24.5117 4.15039 46.2402 4.15039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2891-55.4199C44.3359-55.4199 42.6758-53.8574 42.6758-51.9043L42.6758-31.0059L43.0176-22.2656C43.1152-20.166 44.7266-19.0918 46.2891-19.0918C47.9004-19.0918 49.5605-20.166 49.6094-22.2656L49.9023-31.0059L49.9023-51.9043C49.9023-53.8574 48.291-55.4199 46.2891-55.4199ZM46.2891-15.0879C47.2656-15.0879 47.998-15.3809 48.9258-16.3086L61.9141-28.7109C62.6465-29.3945 62.9883-30.127 62.9883-31.1035C62.9883-32.959 61.5723-34.2773 59.7168-34.2773C58.8379-34.2773 57.8613-33.9355 57.2754-33.2031L51.6602-27.1484L46.2891-21.3867L46.2891-21.3867L40.918-27.1484L35.3516-33.2031C34.7168-33.9355 33.7402-34.2773 32.8613-34.2773C30.957-34.2773 29.5898-32.959 29.5898-31.1035C29.5898-30.127 29.9805-29.3945 30.6641-28.7109L43.7012-16.3086C44.6289-15.3809 45.3613-15.0879 46.2891-15.0879Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdowncirclefill);
export default __webpack_public_path__ + "static/media/arrow.down.circle.fill.8152a5796187061a25035219fd29f523.svg";
export { ForwardRef as ReactComponent };